/* eslint-disable */
export default {
  confirmation: '확인',
  confirmMergeToConference: '전화 회의에 추가하시겠습니까?',
  mergeToConference: '병합',
  conferenceCall: '전화 회의',
} as const;

// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
